import Vue from 'vue'
import VueMask from 'v-mask'

import App from '@shared/App'
import '@shared/assets/scss/main.scss'
import i18n from '@shared/module/i18n'
import axios from '@shared/module/axios'
import Placeholder from '@shared/plugins/Placeholder'
import Reloader from '@shared/plugins/reloader'
import Spinner from '@shared/components/Spinner'
import router from '@shared/router'
import '@shared/module/getid'
import '@shared/module/push-actions'
import '@shared/module/pki'
import '@shared/module/cameraPermissionCallback'

import '@shared/validators'
import '@shared/initialization/amplify'
import '@shared/initialization/analytics'

Vue.use(VueMask)
Vue.use(Placeholder)
Vue.use(Reloader)
Vue.component('Spinner', Spinner)

Vue.config.productionTip = false
Vue.prototype.$http = axios

Vue.directive('focus', {
  inserted: function (el) {
    el.focus()
  }
})

window.vueRoot = new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')

window.onerror = function(message, source, lineno, colno, error) {
  // Errors not handled by Vue (e.g. NPE in "setTimeout" handler)
  const request = {
    name: error.name,
    message: error.message,
    info: 'unhandled',
    location: window.location.href,
    route: window.vueRoot.$route.name,
    source: `${source}:${lineno}:${colno}`,
    stack: String(error.stack || error)
  }
  axios.post('/api/log', request, { headers: { 'Content-Type': 'text/plain' } })
    .catch((loggingError) => {
      console.error('failed to log JS Error:', loggingError, error)
    })
}
